export default __webpack_public_path__ + "static/media/icon-trash.75ebc0c0.svg";